import { useState, useEffect, useCallback } from 'react';
import { bodegaService } from '../services/api';

export default function Bodega() {
  const [tab, setTab] = useState('inventario');
  const [materiales, setMateriales] = useState([]);
  const [compras, setCompras] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [busqueda, setBusqueda] = useState('');
  const [categorias, setCategorias] = useState([]);
  const [nuevoMat, setNuevoMat] = useState(null); // null=cerrado, {} = abierto
  const [ajuste, setAjuste] = useState(null);
  const [editMat, setEditMat] = useState(null);

  // Form de compra
  const [proveedor, setProveedor] = useState('');
  const [fecha, setFecha] = useState(new Date().toISOString().slice(0, 10));
  const [nota, setNota] = useState('');
  const [lineas, setLineas] = useState([{ material_id: '', cantidad: '', precio_unitario: '' }]);
  const [guardando, setGuardando] = useState(false);

  const cargar = useCallback(async () => {
    setLoading(true);
    try {
      const [mat, comp, cat] = await Promise.all([bodegaService.materiales(), bodegaService.compras(), bodegaService.categorias()]);
      setMateriales(mat.data || []);
      setCompras(comp.data || []);
      setCategorias(cat.data || []);
      setError('');
    } catch (err) { setError('Error al cargar la bodega'); }
    finally { setLoading(false); }
  }, []);
  useEffect(() => { cargar(); }, [cargar]);

  const fmt = (n) => '₡' + Number(n || 0).toLocaleString('es-CR');
  const fmtNum = (n) => Number(n || 0).toLocaleString('es-CR');
  const fmtFecha = (f) => f ? new Date(f).toLocaleDateString('es-CR') : '';

  // Agrupar materiales por categoría
  const b = busqueda.trim().toLowerCase();
  const matFiltrados = b ? materiales.filter(m => m.nombre.toLowerCase().includes(b) || (m.categoria || '').toLowerCase().includes(b)) : materiales;
  const porCategoria = {};
  matFiltrados.forEach(m => {
    const cat = m.categoria || 'Sin categoría';
    if (!porCategoria[cat]) porCategoria[cat] = [];
    porCategoria[cat].push(m);
  });

  const setLinea = (idx, campo, valor) => setLineas(prev => prev.map((l, i) => i === idx ? { ...l, [campo]: valor } : l));
  const addLinea = () => setLineas(prev => [...prev, { material_id: '', cantidad: '', precio_unitario: '' }]);
  const removeLinea = (idx) => setLineas(prev => prev.filter((_, i) => i !== idx));

  const guardarCompra = async () => {
    const items = lineas.filter(l => l.material_id && l.cantidad).map(l => ({
      material_id: Number(l.material_id), cantidad: Number(l.cantidad), precio_unitario: Number(l.precio_unitario || 0)
    }));
    if (items.length === 0) { alert('Agregá al menos un material con cantidad'); return; }
    setGuardando(true);
    try {
      await bodegaService.crearCompra({ proveedor, fecha, nota, items });
      setProveedor(''); setNota(''); setLineas([{ material_id: '', cantidad: '', precio_unitario: '' }]);
      alert('Compra registrada. El stock se actualizó.');
      setTab('inventario');
      cargar();
    } catch (err) { alert(err.response?.data?.error || 'Error al registrar la compra'); }
    finally { setGuardando(false); }
  };

  const nuevaCategoria = async () => {
    const nombre = window.prompt("Nombre de la nueva categoría:");
    if (!nombre || !nombre.trim()) return;
    try {
      const r = await bodegaService.crearCategoria(nombre.trim());
      const cats = await bodegaService.categorias();
      setCategorias(cats.data || []);
      if (r.data && r.data.id) setNuevoMat(m => ({ ...m, categoria_id: String(r.data.id) }));
      alert("Categoría creada");
    } catch (err) { alert(err.response?.data?.error || "Error al crear categoría"); }
  };

  const guardarEdicion = async () => {
    if (!editMat.nombre) { alert('Pone el nombre'); return; }
    try {
      await bodegaService.editarMaterial(editMat.id, { categoria_id: editMat.categoria_id || null, nombre: editMat.nombre, unidad: editMat.unidad || 'unidad', stock_minimo: editMat.stock_minimo || 0 });
      setEditMat(null); cargar();
    } catch (err) { alert(err.response?.data?.error || 'Error al editar'); }
  };
  const guardarAjuste = async () => {
    if (ajuste.cantidad === '' || ajuste.cantidad === undefined) { alert('Pone la cantidad'); return; }
    try {
      await bodegaService.ajustarStock(ajuste.id, { modo: ajuste.modo, cantidad: Number(ajuste.cantidad), motivo: ajuste.motivo, nota: ajuste.nota || null });
      setAjuste(null); cargar();
    } catch (err) { alert(err.response?.data?.error || 'Error al ajustar'); }
  };
  const guardarMaterial = async () => {
    if (!nuevoMat.nombre) { alert('Poné el nombre del material'); return; }
    try {
      await bodegaService.crearMaterial({
        categoria_id: nuevoMat.categoria_id || null,
        nombre: nuevoMat.nombre,
        unidad: nuevoMat.unidad || 'unidad',
        stock_minimo: nuevoMat.stock_minimo || 0,
      });
      setNuevoMat(null);
      cargar();
    } catch (err) { alert(err.response?.data?.error || 'Error al crear material'); }
  };

  const totalCompra = lineas.reduce((s, l) => s + (Number(l.cantidad || 0) * Number(l.precio_unitario || 0)), 0);

  const s = {
    tab: (a) => ({ background: a ? '#5c3d2e' : '#e8dfd5', color: a ? '#fff' : '#5c3d2e', border: 'none', padding: '10px 18px', borderRadius: 8, fontWeight: 700, cursor: 'pointer', marginRight: 8 }),
    card: { background: '#fff', borderRadius: 12, padding: 16, marginBottom: 14, boxShadow: '0 1px 6px rgba(0,0,0,0.08)' },
    input: { width: '100%', padding: 10, border: '1px solid #ccc', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' },
    catTitle: { fontWeight: 800, fontSize: 15, color: '#5c3d2e', margin: '14px 0 8px', borderBottom: '2px solid #e0d0c0', paddingBottom: 4 },
    fila: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '8px 0', borderBottom: '1px solid #f0ebe5' },
    btn: { background: '#5c3d2e', color: '#fff', border: 'none', padding: '12px 20px', borderRadius: 8, fontWeight: 700, cursor: 'pointer' },
    btnGhost: { background: '#f0ebe5', color: '#5c3d2e', border: 'none', padding: '8px 14px', borderRadius: 8, fontWeight: 600, cursor: 'pointer' },
  };

  return (
    <div style={{ maxWidth: 900, margin: '0 auto', padding: 20 }}>
      <h1 style={{ color: '#5c3d2e' }}>📦 Bodega</h1>
      <div style={{ marginBottom: 16 }}>
        <button style={s.tab(tab === 'inventario')} onClick={() => setTab('inventario')}>Inventario</button>
        <button style={s.tab(tab === 'compra')} onClick={() => setTab('compra')}>Registrar Compra</button>
        <button style={s.tab(tab === 'historial')} onClick={() => setTab('historial')}>Historial</button>
      </div>

      {loading && <p>Cargando…</p>}
      {error && <p style={{ color: '#c0392b' }}>{error}</p>}

      {tab === 'inventario' && !loading && (
        <>
          <div style={{ display: "flex", gap: 8, marginBottom: 16 }}>
            <input style={s.input} placeholder="🔍 Buscar material o categoría..." value={busqueda} onChange={e => setBusqueda(e.target.value)} />
            <button style={{ ...s.btn, whiteSpace: "nowrap" }} onClick={() => setNuevoMat({ categoria_id: "", nombre: "", unidad: "unidad", stock_minimo: "" })}>➕ Agregar material</button>
          </div>
          {nuevoMat && (
            <div style={s.card}>
              <h3 style={{ color: "#5c3d2e", marginTop: 0 }}>Nuevo material</h3>
              <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
                <div>
                  <label>Categoría</label>
                  <select style={s.input} value={nuevoMat.categoria_id} onChange={e => setNuevoMat({ ...nuevoMat, categoria_id: e.target.value })}>
                    <option value="">— Sin categoría —</option>
                    {categorias.map(cat => <option key={cat.id} value={cat.id}>{cat.nombre}</option>)}
                  </select>
                  <button style={{ ...s.btnGhost, marginTop: 6, fontSize: 12 }} onClick={nuevaCategoria}>➕ Nueva categoría</button>
                </div>
                <div>
                  <label>Unidad</label>
                  <input style={s.input} value={nuevoMat.unidad} onChange={e => setNuevoMat({ ...nuevoMat, unidad: e.target.value })} placeholder="unidad, metro, galón..." />
                </div>
              </div>
              <div style={{ marginBottom: 10 }}>
                <label>Nombre del material *</label>
                <input style={s.input} value={nuevoMat.nombre} onChange={e => setNuevoMat({ ...nuevoMat, nombre: e.target.value })} placeholder="Ej: Tornillo 8x2" />
              </div>
              <div style={{ marginBottom: 10 }}>
                <label>Stock mínimo (alerta) — opcional</label>
                <input style={s.input} type="number" value={nuevoMat.stock_minimo} onChange={e => setNuevoMat({ ...nuevoMat, stock_minimo: e.target.value })} placeholder="0" />
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <button style={s.btn} onClick={guardarMaterial}>Guardar</button>
                <button style={s.btnGhost} onClick={() => setNuevoMat(null)}>Cancelar</button>
              </div>
            </div>
          )}
          {Object.keys(porCategoria).length === 0 && <div style={s.card}>No hay materiales.</div>}
          {Object.entries(porCategoria).map(([cat, mats]) => (
            <div key={cat} style={s.card}>
              <div style={s.catTitle}>{cat}</div>
              {mats.map(m => {
                const bajo = Number(m.stock) <= Number(m.stock_minimo) && Number(m.stock_minimo) > 0;
                return (
                  <div key={m.id} style={s.fila}>
                    <span style={{ color: '#333' }}>{m.nombre}</span>
                    <span style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                      <span style={{ fontWeight: 700, color: bajo ? '#c0392b' : '#1e7e34' }}>
                        {fmtNum(m.stock)} {m.unidad}{bajo && ' ⚠️'}
                      </span>
                      <button style={{ ...s.btnGhost, padding: '4px 10px', fontSize: 13 }} onClick={() => setAjuste({ id: m.id, nombre: m.nombre, unidad: m.unidad, stock: m.stock, modo: 'fijar', cantidad: '', motivo: 'Conteo fisico', nota: '' })}>Ajustar</button>
                      <button style={{ ...s.btnGhost, padding: '4px 10px', fontSize: 13 }} onClick={() => setEditMat({ id: m.id, categoria_id: m.categoria_id ? String(m.categoria_id) : '', nombre: m.nombre, unidad: m.unidad, stock_minimo: m.stock_minimo })}>Editar</button>
                    </span>
                  </div>
                );
              })}
            </div>
          ))}
        </>
      )}

      {tab === 'compra' && !loading && (
        <div style={s.card}>
          <h3 style={{ color: '#5c3d2e', marginTop: 0 }}>Registrar compra</h3>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12, marginBottom: 12 }}>
            <div><label>Proveedor</label><input style={s.input} value={proveedor} onChange={e => setProveedor(e.target.value)} placeholder="Nombre del proveedor" /></div>
            <div><label>Fecha</label><input style={s.input} type="date" value={fecha} onChange={e => setFecha(e.target.value)} /></div>
          </div>
          <label>Materiales comprados</label>
          {lineas.map((l, idx) => (
            <div key={idx} style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr auto', gap: 8, marginBottom: 8, alignItems: 'center' }}>
              <select style={s.input} value={l.material_id} onChange={e => setLinea(idx, 'material_id', e.target.value)}>
                <option value="">— Material —</option>
                {materiales.map(m => <option key={m.id} value={m.id}>{m.categoria} · {m.nombre}</option>)}
              </select>
              <input style={s.input} type="number" placeholder="Cantidad" value={l.cantidad} onChange={e => setLinea(idx, 'cantidad', e.target.value)} />
              <input style={s.input} type="number" placeholder="Precio unit." value={l.precio_unitario} onChange={e => setLinea(idx, 'precio_unitario', e.target.value)} />
              {lineas.length > 1 && <button style={s.btnGhost} onClick={() => removeLinea(idx)}>✕</button>}
            </div>
          ))}
          <button style={{ ...s.btnGhost, marginTop: 4 }} onClick={addLinea}>+ Agregar material</button>
          <div style={{ marginTop: 12 }}><label>Nota (opcional)</label><input style={s.input} value={nota} onChange={e => setNota(e.target.value)} /></div>
          <div style={{ textAlign: 'right', fontSize: 18, fontWeight: 800, color: '#5c3d2e', margin: '12px 0' }}>Total: {fmt(totalCompra)}</div>
          <button style={{ ...s.btn, width: '100%', opacity: guardando ? 0.7 : 1 }} onClick={guardarCompra} disabled={guardando}>
            {guardando ? 'Guardando…' : 'Registrar compra y sumar al stock'}
          </button>
        </div>
      )}

      {editMat && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, maxWidth: 420, width: '100%' }}>
            <h3 style={{ color: '#5c3d2e', marginTop: 0 }}>Editar material</h3>
            <label>Nombre</label>
            <input style={s.input} value={editMat.nombre} onChange={e => setEditMat({ ...editMat, nombre: e.target.value })} />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginTop: 10 }}>
              <div>
                <label>Categoria</label>
                <select style={s.input} value={editMat.categoria_id} onChange={e => setEditMat({ ...editMat, categoria_id: e.target.value })}>
                  <option value=''>Sin categoria</option>
                  {categorias.map(cat => <option key={cat.id} value={cat.id}>{cat.nombre}</option>)}
                </select>
              </div>
              <div>
                <label>Unidad</label>
                <input style={s.input} value={editMat.unidad} onChange={e => setEditMat({ ...editMat, unidad: e.target.value })} />
              </div>
            </div>
            <div style={{ marginTop: 10 }}>
              <label>Stock minimo (alerta) - pone 0 para quitar la alerta</label>
              <input style={s.input} type='number' value={editMat.stock_minimo} onChange={e => setEditMat({ ...editMat, stock_minimo: e.target.value })} />
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button style={s.btn} onClick={guardarEdicion}>Guardar cambios</button>
              <button style={s.btnGhost} onClick={() => setEditMat(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {ajuste && (
        <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, padding: 20 }}>
          <div style={{ background: '#fff', borderRadius: 12, padding: 20, maxWidth: 420, width: '100%' }}>
            <h3 style={{ color: '#5c3d2e', marginTop: 0 }}>Ajustar: {ajuste.nombre}</h3>
            <p style={{ color: '#8a7a6a', fontSize: 14 }}>Stock actual: <strong>{fmtNum(ajuste.stock)} {ajuste.unidad}</strong></p>
            <label>Tipo de ajuste</label>
            <select style={s.input} value={ajuste.modo} onChange={e => setAjuste({ ...ajuste, modo: e.target.value })}>
              <option value='fijar'>Poner cantidad exacta</option>
              <option value='sumar'>Sumar (agregar)</option>
              <option value='restar'>Restar (quitar)</option>
            </select>
            <div style={{ marginTop: 10 }}>
              <label>Cantidad</label>
              <input style={s.input} type='number' value={ajuste.cantidad} onChange={e => setAjuste({ ...ajuste, cantidad: e.target.value })} placeholder='0' />
            </div>
            <div style={{ marginTop: 10 }}>
              <label>Motivo</label>
              <select style={s.input} value={ajuste.motivo} onChange={e => setAjuste({ ...ajuste, motivo: e.target.value })}>
                <option value='Conteo fisico'>Conteo fisico</option>
                <option value='Existencia inicial'>Existencia inicial</option>
                <option value='Material danado'>Material danado</option>
                <option value='Salida / uso'>Salida / uso</option>
                <option value='Correccion'>Correccion</option>
                <option value='Otro'>Otro</option>
              </select>
            </div>
            <div style={{ marginTop: 10 }}>
              <label>Nota (opcional)</label>
              <input style={s.input} value={ajuste.nota} onChange={e => setAjuste({ ...ajuste, nota: e.target.value })} />
            </div>
            <div style={{ display: 'flex', gap: 8, marginTop: 16 }}>
              <button style={s.btn} onClick={guardarAjuste}>Guardar ajuste</button>
              <button style={s.btnGhost} onClick={() => setAjuste(null)}>Cancelar</button>
            </div>
          </div>
        </div>
      )}

      {tab === 'historial' && !loading && (
        <>
          {compras.length === 0 && <div style={s.card}>No hay compras registradas.</div>}
          {compras.map(c => (
            <div key={c.id} style={s.card}>
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <strong style={{ color: '#5c3d2e' }}>{c.proveedor || 'Sin proveedor'}</strong>
                <span style={{ fontWeight: 700, color: '#1e7e34' }}>{fmt(c.total)}</span>
              </div>
              <div style={{ fontSize: 13, color: '#8a7a6a' }}>{fmtFecha(c.fecha)}{c.usuario && ` · ${c.usuario}`}</div>
              {c.nota && <div style={{ fontSize: 13, color: '#8a7a6a', fontStyle: 'italic' }}>{c.nota}</div>}
            </div>
          ))}
        </>
      )}
    </div>
  );
}
